import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Common, NewCommon } from "./wrappers";

export default class IceHokeyTracker extends Component {
	render({ event, lastEventName = event.misc.tracker.name }) {
		if (!event.misc.info)
			return null;
		return <NewCommon event={event}>
			<div class={"field field-" + event.misc.info.field}>
				<div
					key="animation-container"
					class={`animation-container ${lastEventName} ${event.misc.tracker.team || "home"}`}
				>
					{lastEventName === "Attack" || lastEventName === "DangerousAttack" ? (
						<div class="new-attack-div">
							<div class="new-attack-dir" />
						</div>
					) : null}

					{lastEventName === "Goal" ? (
						<div class="goal-animation-frame">
							<p class="new-goal-text">
								<h1 class="goal-text-title">Goal</h1>
								<span class="goal-sub-text">{event.teams[event.misc.tracker.team].name}</span>
							</p>
						</div>
					) : null}
				</div>
			</div>
			<div class="tk-action-container pt-1">
				<div class="bg-gray-500-7 px-2 py-2 rounded flex space-between">
					<div class="">{lastEventName.replace(/[A-Z]/g, (letter, idx) => (idx == 0 ? letter : ` ${letter}`))}</div>
					<div
						style={{
							"border-right": `2px solid #${
								event.misc.info[`shirt${event.misc.tracker.team == "home" ? 1 : 2}_color`]
							}`,
							"padding-right": "5px",
						}}
					>
						{event.teams[event.misc.tracker.team].name}
					</div>
				</div>
			</div>
		</NewCommon>;
	}
}
